import { environment } from '@env/environment';
import { InteractionType, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
const isInIframe = window !== window.parent && !window.opener;

export function loggerCallback(logLevel: LogLevel, message: string) {
  // console.log(logLevel, message);
}

export const MsalConfiguration = new PublicClientApplication({
  auth: {
    clientId: environment.clientId,
    authority: `https://login.microsoftonline.com/${environment.tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: null,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: environment.cacheLocation,
    storeAuthStateInCookie: isIE
  },
  system: {
    tokenRenewalOffsetSeconds: 300,
    loggerOptions: {
      loggerCallback,
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false
    }
  }
});

export const MsalGuardConfig: MsalGuardConfiguration = {
  interactionType: isInIframe ? InteractionType.Popup : InteractionType.Redirect,
  authRequest: {
    scopes: ['User.Read']
  }
};

export const MsalInterceptorConfig: MsalInterceptorConfiguration = {
  interactionType: isInIframe ? InteractionType.Popup : InteractionType.Redirect,
  protectedResourceMap: new Map([[environment.apiBaseUrl, ['User.Read']]])
};
